// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2icR0","signatureButtonsRight":"ModalSign_signatureButtonsRight__1eXqw"};